import { Grid } from '@material-ui/core';
import {
  EntityGithubActionsContent,
  isGithubActionsAvailable,
} from '@backstage-community/plugin-github-actions';
import { EntitySonarQubeCard, EntitySonarQubeContentPage, SonarQubeRelatedEntitiesOverview } from '@backstage-community/plugin-sonarqube';
import { isSonarQubeAvailable } from '@backstage-community/plugin-sonarqube-react';
import { EntityTeamPullRequestsCard } from '@backstage-community/plugin-github-pull-requests-board';
import {
EntityGithubInsightsContent,
EntityGithubInsightsLanguagesCard,
EntityGithubInsightsReadmeCard,
EntityGithubInsightsReleasesCard,
isGithubInsightsAvailable,
} from '@roadiehq/backstage-plugin-github-insights';
import { EntityStackPoliciesCard } from '@internal/plugin-stack-policies';
import {
  EntityRailwayCostCard,
  isRailwayCostAvailable,
} from '@internal/plugin-railway-cost';
import {
  EntityAdrContent,
  isAdrAvailable,
} from '@backstage-community/plugin-adr';
import {
  EntityDbmlContent,
  isDbmlAvailable,
} from '@internal/plugin-dbml-schema';
import {
  EntityApiDefinitionCard,
  EntityConsumedApisCard,
  EntityConsumingComponentsCard,
  EntityHasApisCard,
  EntityProvidedApisCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import {
  EntityAboutCard,
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityHasComponentsCard,
  EntityHasResourcesCard,
  EntityHasSubcomponentsCard,
  EntityHasSystemsCard,
  EntityLinksCard,
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  isComponentType,
  isKind,
  hasCatalogProcessingErrors,
  isOrphan,
  hasRelationWarnings,
  EntityRelationWarning,
} from '@backstage/plugin-catalog';
import {
  EntityUserProfileCard,
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { InfoCard } from '@backstage/core-components';
import {
  EntityLikeDislikeRatingsCard,
  LikeDislikeButtons,
} from '@backstage-community/plugin-entity-feedback';
import { EntityFeedbackPage } from './EntityFeedbackPage';
import { FluxEntityLayout } from './entity-layout/FluxEntityLayout';
import {
  Direction,
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';

import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';

import {
  EntityKubernetesContent,
  isKubernetesAvailable,
} from '@backstage/plugin-kubernetes';

const techdocsContent = (
  <EntityTechdocsContent>
    <TechDocsAddons>
      <ReportIssue />
    </TechDocsAddons>
  </EntityTechdocsContent>
);

const entityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid item xs={12}>
          <EntityOrphanWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Grid item xs={12}>
          <EntityRelationWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid item xs={12}>
          <EntityProcessingErrorsPanel />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

const overviewContent = (
  
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} />
    </Grid>
    <Grid item md={12} xs={12}>
      <EntityStackPoliciesCard />
    </Grid>
    <EntitySwitch>
      <EntitySwitch.Case if={isRailwayCostAvailable}>
        <Grid item md={6} xs={12}>
          <EntityRailwayCostCard />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
    <Grid item md={4} xs={12}>
      <InfoCard title="Calificar este componente">
        <LikeDislikeButtons
          feedbackDialogTitle="¿Qué podríamos mejorar?"
          requestResponse
        />
      </InfoCard>
    </Grid>
    <EntitySwitch>
      <EntitySwitch.Case if={e => Boolean(isGithubInsightsAvailable(e))}>
        <Grid item md={6}>
          <EntityGithubInsightsLanguagesCard />
          <EntityGithubInsightsReleasesCard />
        </Grid>
        <Grid item md={6}>
          <EntityGithubInsightsReadmeCard maxHeight={350} />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={isSonarQubeAvailable}>
        <Grid item md={6}>
          <EntitySonarQubeCard variant="gridItem" />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid>
  </Grid>
);

const serviceEntityPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/github-actions"
      title="GitHub Actions"
      if={isGithubActionsAvailable}
    >
      <EntityGithubActionsContent view="cards" />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route 
      path="/code-insights"
      title="Code Insights">
      <EntityGithubInsightsContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/kubernetes"
      title="Kubernetes"
      if={isKubernetesAvailable}
    >
      <EntityKubernetesContent />
    </FluxEntityLayout.Route>

     <FluxEntityLayout.Route path="/feedback" title="Feedback">
      <EntityFeedbackPage />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/sonarqube"
      title="SonarQube"
      if={isSonarQubeAvailable}
    >
      <EntitySonarQubeContentPage />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/api" title="API">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityProvidedApisCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityConsumedApisCard variant="gridItem" />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/dependencies" title="Dependencies">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityDependsOnComponentsCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityDependsOnResourcesCard variant="gridItem" />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route if={isDbmlAvailable} path="/schema" title="Schema">
      <EntityDbmlContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route if={isAdrAvailable} path="/adrs" title="ADRs">
      <EntityAdrContent />
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

const websiteEntityPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/github-actions"
      title="GitHub Actions"
      if={isGithubActionsAvailable}
    >
      <EntityGithubActionsContent view="cards" />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/code-insights"
      title="Code Insights"
      if={e => Boolean(isGithubInsightsAvailable(e))}
    >
      <EntityGithubInsightsContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/kubernetes"
      title="Kubernetes"
      if={isKubernetesAvailable}
    >
      <EntityKubernetesContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/feedback" title="Feedback">
      <EntityFeedbackPage />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/sonarqube"
      title="SonarQube"
      if={isSonarQubeAvailable}
    >
      <EntitySonarQubeContentPage />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/dependencies" title="Dependencies">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityDependsOnComponentsCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityDependsOnResourcesCard variant="gridItem" />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route if={isDbmlAvailable} path="/schema" title="Schema">
      <EntityDbmlContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route if={isAdrAvailable} path="/adrs" title="ADRs">
      <EntityAdrContent />
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

/**
 * NOTE: This page is designed to work on small screens such as mobile devices.
 * This is based on Material UI Grid. If breakpoints are used, each grid item must set the `xs` prop to a column size or to `true`,
 * since this does not default. If no breakpoints are used, the items will equitably share the available space.
 * https://material-ui.com/components/grid/#basic-grid.
 */

const defaultEntityPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/github-actions"
      title="GitHub Actions"
      if={isGithubActionsAvailable}
    >
      <EntityGithubActionsContent view="cards" />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/code-insights"
      title="Code Insights"
      if={e => Boolean(isGithubInsightsAvailable(e))}
    >
      <EntityGithubInsightsContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route if={isDbmlAvailable} path="/schema" title="Schema">
      <EntityDbmlContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route if={isAdrAvailable} path="/adrs" title="ADRs">
      <EntityAdrContent />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/feedback" title="Feedback">
      <EntityFeedbackPage />
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route
      path="/sonarqube"
      title="SonarQube"
      if={isSonarQubeAvailable}
    >
      <EntitySonarQubeContentPage />
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

const componentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {websiteEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);

const apiPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid container item md={12}>
          <Grid item md={6}>
            <EntityProvidingComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityConsumingComponentsCard />
          </Grid>
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>

    <FluxEntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

const userPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityUserProfileCard variant="gridItem" />
        </Grid>
        <Grid item xs={12}>
          <EntityLikeDislikeRatingsCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard variant="gridItem" />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

const groupPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityGroupProfileCard variant="gridItem" />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard variant="gridItem" />
        </Grid>
        <Grid item xs={12}>
          <EntityMembersListCard />
        </Grid>
        <Grid item xs={12}>
          <EntityTeamPullRequestsCard />
        </Grid>
        <Grid item xs={12}>
          <EntityLikeDislikeRatingsCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityMembersListCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityLinksCard />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

const systemPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard variant="gridItem" />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid item md={8}>
          <EntityHasComponentsCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityHasApisCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityHasResourcesCard variant="gridItem" />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>
    <FluxEntityLayout.Route path="/sonarqube" title="Code Quality">
      <SonarQubeRelatedEntitiesOverview relationType={RELATION_HAS_PART} entityKind="component" />
    </FluxEntityLayout.Route>
    <FluxEntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        variant="gridItem"
        direction={Direction.TOP_BOTTOM}
        title="System Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_HAS_PART,
          RELATION_API_CONSUMED_BY,
          RELATION_API_PROVIDED_BY,
          RELATION_CONSUMES_API,
          RELATION_PROVIDES_API,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

const domainPage = (
  <FluxEntityLayout>
    <FluxEntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard variant="gridItem" />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={6}>
          <EntityHasSystemsCard variant="gridItem" />
        </Grid>
      </Grid>
    </FluxEntityLayout.Route>
  </FluxEntityLayout>
);

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')} children={componentPage} />
    <EntitySwitch.Case if={isKind('api')} children={apiPage} />
    <EntitySwitch.Case if={isKind('group')} children={groupPage} />
    <EntitySwitch.Case if={isKind('user')} children={userPage} />
    <EntitySwitch.Case if={isKind('system')} children={systemPage} />
    <EntitySwitch.Case if={isKind('domain')} children={domainPage} />

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
